import { useTranslation } from "react-i18next";

import emptyBalanceImg from "../../assets/images/buy-and-supply-balance-empty-state.png";
import emptyDataImg from "../../assets/images/buy-and-supply-empty-state.png";
import emptyPendingOrdersImg from "../../assets/images/buy-and-supply-pending-orders-empty-state.png";

const EmptyState = ({ data }) => {
  const { t } = useTranslation();
  const isOrders = data === "orders" || data === "pending orders";

  return (
    <div
      className={`buy-and-supply__empty-state ${
        data === "balance"
          ? " buy-and-supply__empty-state--balance"
          : isOrders
            ? " buy-and-supply__empty-state--pending-orders"
            : ""
      } py-5 my-5 d-flex flex-column align-items-center`}
    >
      <img
        src={
          data === "items"
            ? emptyDataImg
            : data === "balance"
              ? emptyBalanceImg
              : emptyPendingOrdersImg
        }
        alt=""
        className="d-block img-fluid"
        loading="lazy"
      />
      <p className="fsize-4 fw-bold">{t("buyAndSupply.pageIsEmpty")}</p>
      <p className="fsize-5 fw-500 mb-0">
        {t(
          `buyAndSupply.${
            data === "balance"
              ? "checkBalanceLater"
              : isOrders
                ? "emptyOrders"
                : "checkItemsLater"
          }`,
        )}
      </p>
    </div>
  );
};

export default EmptyState;
